import { jsx as _jsx } from "react/jsx-runtime";
import { DEFAULT_FREQUENCY, DEFAULT_LAYERS, } from "@erikwatson/snowfall";
import { useDispatch } from "react-redux";
import { Control } from "../../../../control/control";
import { Range } from "../../../../range/range";
import { setSwayFrequency } from "../../../../../features/config/config.slice";
export const SnowflakeSwayFrequency = ({ index, layer, }) => {
    const dispatch = useDispatch();
    return (_jsx(Control, { name: "Frequency", tooltip: "The frequency of the sway", showOutput: true, reset: () => {
            const frequency = index < DEFAULT_LAYERS.length ? DEFAULT_LAYERS[index].sway.frequency : DEFAULT_FREQUENCY;
            dispatch(setSwayFrequency({
                index,
                frequency
            }));
        }, value: layer.sway.frequency, onChange: (event) => dispatch(setSwayFrequency({
            index,
            frequency: Number(event.target.value),
        })), children: _jsx(Range, { min: "0", max: "10", step: "0.001" }) }));
};
